<template>
    <div :class="{'ly-is-full':isFull}">
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="false" :model="formInline" label-position="left">
                <el-form-item label="货号：">
                    <el-input v-model.trim="formInline.no" maxlength="60"  clearable placeholder="货号" @change="search" style="width:160px"></el-input>
                </el-form-item>
                <el-form-item label="定价日期：">
                    <el-date-picker
                            style="width:350px"
                            v-model="timers"
                            type="datetimerange"
                            @change="timeChange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="" v-show="hasPermission(route.name,'Search')"><el-button  @click="search" type="primary" icon="Search">查询</el-button></el-form-item>
                <el-form-item label=""><el-button @click="handleEdit('','reset')" icon="Refresh">重置</el-button></el-form-item>
                <el-form-item label=""><el-button type="primary" @click="handleEdit('','add')">新增</el-button></el-form-item>
                <el-form-item label=""><el-button type="primary" @click="exportData" :disabled="loadingPage">导出</el-button></el-form-item>
            </el-form>
        </div>
        <el-table :height="tableHeight" border :data="tableData" ref="tableref" v-loading="loadingPage" style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" width="60" align="center" label="序号">
                <template #default="scope">
                    <span v-text="getIndex(scope.$index)" class="lyexportexclude"></span>
                </template>
            </el-table-column>
            <el-table-column min-width="180" prop="dj_time" label="定价日期"></el-table-column>
            <el-table-column min-width="100" prop="goodsinfo.category_name" label="品类"></el-table-column>
            <el-table-column min-width="220" prop="goodsinfo.no" label="货号"></el-table-column>
            <el-table-column min-width="100" prop="goodsinfo.spec" label="规格"></el-table-column>
            <el-table-column min-width="120" prop="goodsinfo.image" label="商品图">
                <template #default="scope">
                    <el-image  :src=scope.row.goodsinfo.image :preview-src-list="[scope.row.goodsinfo.image]" :preview-teleported="true" style="width: 30px;height: 30px"></el-image>
                </template>
            </el-table-column>
            <el-table-column min-width="100" prop="goodsinfo.ru_dingjia" label="入库定价(k)"></el-table-column>
            <el-table-column min-width="100" prop="cu_price" label="出库单价(k)"></el-table-column>
            <el-table-column min-width="130" prop="remark" label="备注" show-overflow-tooltip></el-table-column>
        </el-table>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <ly-dialog v-model="isDialogShow" :title="dialogTitle" width="60%" top="10px" :before-close="handleDialogClose">
            <el-form :inline="false" :model="formData" :rules="rules" ref="rulesForm" label-position="right" label-width="auto">
                <div class="ly-title">
                    基础信息
                </div>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="经手人" prop="jingshou">
                            <el-input v-model="formData.jingshou" placeholder="请输入" :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="定价日期" prop="dj_time">
                            <el-date-picker
                                style="width: 100%"
                                v-model="formData.dj_time"
                                type="datetime"
                                placeholder="选择时间"
                                format="YYYY-MM-DD HH:mm:ss"
                                value-format="YYYY-MM-DD HH:mm:ss"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="ly-title">
                    明细
                </div>
                <el-form-item prop="goodslist">
                    <el-table :data="formData.goodslist" ref="lyaddtable" border stripe>
                        <el-table-column type="index" width="60" fixed="left">
                            <template #header>
                                <ly-table-select button-type="primary" button-icon="plus" size="small" :button-circle="true" ref="lymanualSelect" :apiObj="getGoodsApi" @click="handleManualSelectClick" :table-width="800" multiple @confirm="handleManualConfirmClick">
                                    <template #header="{form, submit}">
                                        <el-form :inline="true" :model="form">
                                            <el-form-item>
                                                <el-date-picker
                                                    size="small"
                                                    style="width:320px"
                                                    v-model="form.timerange"
                                                    type="datetimerange"
                                                    range-separator="至"
                                                    start-placeholder="创建开始日期"
                                                    end-placeholder="创建结束日期">
                                                </el-date-picker>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-input type="text" v-model="form.no" placeholder="货号" size="small" style="width: 120px;" clearable></el-input>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-select  v-model="form.category" placeholder="品类" clearable style="width: 120px;" size="small">
                                                    <el-option
                                                        v-for="item in categoryList"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-button type="primary" @click="submit" size="small">查询</el-button>
                                            </el-form-item>
                                        </el-form>
                                    </template>
                                    <el-table-column prop="category_name" label="品类" show-overflow-tooltip min-width="100"></el-table-column>
                                    <el-table-column prop="no" label="货号" show-overflow-tooltip min-width="150"></el-table-column>
                                    <el-table-column prop="spec" label="规格" show-overflow-tooltip min-width="100"></el-table-column>
                                    <el-table-column prop="image" label="商品图"  min-width="130">
                                        <template #default="scope">
                                            <el-image  :src=scope.row.image :preview-src-list="[scope.row.image]" :preview-teleported="true" style="width: 35px;height: 35px"></el-image>
                                        </template>
                                    </el-table-column>
                                </ly-table-select>
                            </template>
                            <template #default="scope">
                                <div class="ly-form-table-handle">
                                    <span>{{scope.$index + 1}}</span>
                                    <el-button type="danger" icon="delete" size="small" plain circle @click="rowDel(scope.row, scope.$index)"></el-button>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="goodsinfo.category_name" label="品类" min-width="120"></el-table-column>
                        <el-table-column prop="goodsinfo.no" label="货号" min-width="180" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="goodsinfo.image" label="商品图" min-width="130">
                            <template #default="scope">
                                <el-image  :src=scope.row.goodsinfo.image :preview-src-list="[scope.row.goodsinfo.image]" :preview-teleported="true" style="width: 30px;height: 30px"></el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="goodsinfo.spec" label="规格" min-width="100"></el-table-column>
                        <el-table-column prop="goodsinfo.ru_dingjia" label="入库定价(k)" min-width="100"></el-table-column>
                        <el-table-column prop="cu_price" label="出库单价(k)" min-width="180">
                             <template #header>
                                <span style="color: red">*</span>出库单价(k)
                            </template>
                            <template #default="scope">
                                <el-input v-model="scope.row.cu_price" placeholder="输入" v-limitPositiveNumberFixed2></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="remark" label="备注" min-width="180">
                            <template #default="scope">
                                <el-input v-model="scope.row.remark" placeholder="输入"></el-input>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="handleDialogClose" :loading="loadingSave">取消</el-button>
                <el-button type="primary" @click="submitData" :loading="loadingSave">确定</el-button>
            </template>
        </ly-dialog>
    </div>
</template>

<script setup>
    import {ref,reactive,onMounted,onBeforeUnmount,nextTick} from 'vue'
    import { ElMessage,ElMessageBox } from 'element-plus';
    import Pagination from "@/components/Pagination";
    import {hasPermission, dateFormats, getStorage, lyParseParam2UrlParam} from "@/utils/util";
    import {psiGoodstj,psiStore,psiGoods,psiCategory,psiGoodstjAdd,psiGoodstjExport} from '@/api/api'
    import useTableHight from '@/mixins/useTableHight';
    import { useRouter,useRoute } from 'vue-router'
    import LyDialog from "@/components/dialog/dialog";
    import LyTableSelect from "@/components/lyTableSelect";
    const route = useRoute()

    let isFull = ref(false)
    let orderStatic = ref(null)
    let tableSelect = ref(null)
    let tableHeight = useTableHight(orderStatic,tableSelect,isFull.value)
    let loadingPage = ref(false)
    let loadingSave = ref(false)
    let isDialogShow = ref(false)
    let dialogTitle = ref("")
    let formData = ref({})
    let storeList = ref([])
    let categoryList = ref([])
    let userName =getStorage("userName")
    let rules = reactive({
        dj_time: [
            {required: true, message: '请选择定价日期',trigger: 'blur'}
        ],
    })
    function handleDialogClose(){
        isDialogShow.value = false
        formData.value = {}
    }
    let formInline = ref({
        page: 1,
        limit: 10,
    })

    let defaultImg = ref(require('../../assets/img/avatar.jpg'))
    let pageparm = ref({
        page: 1,
        limit: 10,
        total: 0
    })
    let tableData = ref([])
    let timers = ref([])
    let typeList = ref([])
    let statusList = ref([
        {id:3,name:'已完成'},
        {id:1,name:'待审核'},
        {id:2,name:'已拒绝'},
    ])

    function getStoreList() {
        psiStore({page:1,limit:999}).then(res=>{
            if(res.code == 2000){
                storeList.value = res.data.data
            }
        })
    }
    function getCategoryList() {
        psiCategory({page:1,limit:999}).then(res=>{
            if(res.code == 2000){
                categoryList.value = res.data.data
            }
        })
    }

    let lymanualSelect = ref(null)
    function handleManualSelectClick(){
        // if(formData.store == ""){
        //     ElMessage.warning("请选择仓库")
        //     return
        // }
        lymanualSelect.value.handleChooseClick()
    }
    function handleManualConfirmClick(items){
        //去重赋值
        if(items.length>0){
            items.forEach(item=>{
                //如果不存在返回值为-1(去重)
                if(formData.value.goodslist.findIndex(item1=>item1.goodsinfo.id === item.id ) == -1){
                    formData.value.goodslist.push({
                        goodsinfo:item,
                        cu_price:null,
                        remark:""
                    })
                }
            })
        }
    }
    function getGoodsApi() {
        return psiGoods
    }
    //提交保存数据
    let rulesForm = ref(null)
    function submitData(){
        rulesForm.value.validate(obj=>{
            if(obj) {
                loadingSave.value=true
                let param = {
                    ...formData.value
                }
                var goodslist = param.goodslist
                var ispass = true
                for(var i =0;i<goodslist.length;i++){
                    if(!!goodslist[i].cu_price ==false){
                        ispass = false
                        break
                    }
                }
                if(!ispass){
                    ElMessage.warning("必填内容不能为空，请填写后再提交")
                    loadingSave.value=false
                    return
                }
                psiGoodstjAdd(param).then(res=>{
                    loadingSave.value=false
                    if(res.code ==2000) {
                        ElMessage.success(res.msg)
                        handleDialogClose()
                        getData()
                    } else {
                       ElMessage.warning(res.msg)
                    }
                })

            }
        })
    }

    function isobject(item){
        if(typeof(item) == "object"){
            return true
        }else{
            return false
        }
    }
    function setFull(){
        isFull.value=!isFull.value
        window.dispatchEvent(new Event('resize'))
    }
    // 表格序列号
    function getIndex($index) {
        // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
        return (pageparm.value.page-1)*pageparm.value.limit + $index +1
    }

    // 选项框选中数组
    let ids = ref([])
    // 选项框非单个禁用
    let single = ref(true)
    // 非多个禁用
    let multiple = ref(true)
    //多选项框被选中数据
    function handleSelectionChange(selection) {
        ids.value = selection.map(item => item.id);
        single.value = selection.length !== 1;
        multiple.value = !selection.length;
    }
     /** 添加表格操作 */
    function rowDel(row, index){
        formData.value.goodslist.splice(index, 1)
    }
    function handleEdit(row,flag) {
        if(flag=="reset"){
            formInline.value = {
                page:1,
                limit: 10
            }
            pageparm.value={
                page: 1,
                limit: 10,
                total: 0
            }
            timers.value = []
            search()
        }else if(flag === 'add'){
            dialogTitle = "添加商品调价单"
            formData.value.jingshou = userName
            formData.value.dj_time = dateFormats(new Date(),'yyyy-MM-dd hh:mm:ss')
            formData.value.goodslist = []
            isDialogShow.value = true
        }
    }

    function callFather(parm) {
        formInline.value.page = parm.page
        formInline.value.limit = parm.limit
        getData()
    }
    function search() {
        formInline.value.page = 1
        formInline.value.limit = 10
        getData()
    }

    //获取列表
    async function getData(){
        loadingPage.value = true
        psiGoodstj(formInline.value).then(res => {
            loadingPage.value = false
            if(res.code ==2000) {
                tableData.value = res.data.data
                pageparm.value.page = res.data.page;
                pageparm.value.limit = res.data.limit;
                pageparm.value.total = res.data.total;
            }
        })
    }
    function timeChange(val){
        if (val) {
            formInline.value.beginAt=dateFormats(val[0],'yyyy-MM-dd hh:mm:ss');
            formInline.value.endAt=dateFormats(val[1],'yyyy-MM-dd hh:mm:ss');
        } else {
            formInline.value.beginAt = null
            formInline.value.endAt = null
        }
        search()
    }
    // // 下载文件URL文件
    // function downloadFileURL(url) {
    //     var iframe =document.createElement("iframe")
    //     iframe.style.display ="none";
    //     iframe.src = url;
    //     document.body.appendChild(iframe);
    // }
    //
    // function exportData(){
    //     psiGoodsinstoreExport(formInline).then(res => {
    //          if(res.code ==2000) {
    //              downloadFileURL(res.data.data)
    //          }else{
    //               ElMessage.warning(res.msg)
    //          }
    //      })
    //
    // }
    //excel文件流下载
    function downloadExcelBlob(res) {
        let fileName = new Date().getTime() +".xlsx"
        let dispositionStr = res.headers["content-disposition"];
        if (dispositionStr == null || dispositionStr === "") {

        }else{
            // 获取文件名
            let dispositionArr = dispositionStr.split(";");
            fileName = decodeURIComponent(dispositionArr[1]);
            fileName = fileName.split("=")[1];
        }
        const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let href = window.URL.createObjectURL(blob); //下载链接
        let link = document.createElement("a")
        link.href = href
        link.download = fileName //下载后文件名
        document.body.appendChild(link);
        link.click(); //点击下载
        document.body.removeChild(link); //下载完成移除元素
        window.URL.revokeObjectURL(href);  //释放blob对象
        ElMessage.success('导出成功')
    }
    //导出
    function exportData(row) {
        let params = {}
        let urlparams = lyParseParam2UrlParam(formInline.value)
        urlparams = !!urlparams?"?"+urlparams:''
        if(ids.value.length>0){
            params['ids'] = ids.value
        }
        loadingPage.value = true
        psiGoodstjExport(urlparams,params).then(res => {
            loadingPage.value = false
            downloadExcelBlob(res)
        })
    }

    onMounted(()=>{
        getCategoryList()
        getStoreList()
        getData()
    })

    defineExpose({
        setFull
    })
</script>

<style scoped>
    .ly-title{
        border-bottom: 1px solid #eee;
        margin-bottom: 20px;
        font-size: 17px;
        padding-bottom: 15px;
        color: #3c4a54;
        font-weight: bold;
    }
    .ly-form-table-handle {
        text-align: center;
    }
	.ly-form-table-handle span {
        display: inline-block;
    }
	.ly-form-table-handle button {
        display: none;
    }
    .hover-row .ly-form-table-handle span {
        display: none;
    }
	.hover-row .ly-form-table-handle button {
        display: inline-block;
    }
</style>